// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/demand_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { DemandService } from "./demand_service_pb";

/**
 * ListDemandForecasts returns the display rows for the demand forecast list
 * screen (需要想定一覧). The BFF handler calls backend ListDemandForecasts
 * to retrieve pre-composed rows. Row order is determined by the backend.
 *
 * @generated from rpc bffuser.v1.DemandService.ListDemandForecasts
 */
export const listDemandForecasts = DemandService.method.listDemandForecasts;
